import SetFatigueDrivingAlarmDifferenceModal from './set-fatigue-driving-alarm-difference-modal.vue'
export default SetFatigueDrivingAlarmDifferenceModal
